module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg.fddd84e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg.jpg
// module id = 2891
// module chunks = 11